import styled from 'styled-components';
import { space, layout, border, flexbox, position, shadow, fontSize, } from 'styled-system';
export const BoxBase = styled.div.attrs({
    className: 'box',
}) `
  display: flex;
  box-sizing: border-box;

  color: ${({ color }) => `var(--color-${color})`};
  background: ${({ background }) => `var(--color-${background})`};

  ${layout}
  ${space}
  ${border}
  ${flexbox}
  ${position}
  ${shadow}
  ${fontSize}
`;
